"use client";

import { redirect } from "next/navigation";

import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useFilterSheetContext } from "@/components/sheets/FilterSheet/context";
import {
	filterSheetGlassRadioItemClassName,
	filterSheetHeadingClassName,
	filterSheetRowLabelClassName,
} from "@/components/sheets/FilterSheet/filter-sheet-glass";

type Props = {
	defaultSort: string;
	sorts: Record<string, string>;
};

export default function FilterSortSection({ sorts, defaultSort }: Props) {
	const { pathname, mutSearchParams, setSearchParam } = useFilterSheetContext();
	const currentSort = mutSearchParams.get("sortBy") ?? undefined;

	if (currentSort !== undefined && !(currentSort in sorts)) redirect(pathname);

	return (
		<div className="flex flex-col gap-2">
			<h3 className={filterSheetHeadingClassName}>Sort by</h3>
			<RadioGroup
				value={currentSort}
				defaultValue={defaultSort}
				onValueChange={(x) => setSearchParam("sortBy", x)}
			>
				{Object.entries(sorts).map(([value, label]) => (
					<div key={value} className="grid h-6 grid-cols-[2rem_1fr] items-center">
						<RadioGroupItem
							id={`filter-${value}`}
							value={value}
							className={filterSheetGlassRadioItemClassName}
						/>
						<label htmlFor={`filter-${value}`} className={filterSheetRowLabelClassName}>
							{label}
						</label>
					</div>
				))}
			</RadioGroup>
		</div>
	);
}
